"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var state = {
    agencyId: null,
    agencyPhone: null,
    trackingPixelActivated: false,
};
var actions = {
    activateTrackingPixels: function (store) {
        store.commit('ACTIVATE_TRACKING_PIXELS');
    },
    setAidaSource: function (store, aidaSource) {
        store.commit('SET_AIDA_SOURCE', aidaSource);
    },
    setUserType: function (store, userType) {
        store.commit('SET_USER_TYPE', userType);
    },
};
var getters = {
    affiliateId: function (state) { return state.affiliateId; },
    agencyId: function (state) { return state.agencyId; },
    agencyPhone: function (state) { return state.agencyPhone; },
    trackingPixelActivated: function (state) { return state.trackingPixelActivated; },
};
var mutations = {
    SET_AFFILIATE_ID: function (state, affiliateId) {
        state.affiliateId = affiliateId;
    },
    SET_AGENCY_ID: function (state, agencyId) {
        state.agencyId = agencyId;
    },
    SET_AGENCY_PHONE: function (state, agencyPhone) {
        state.agencyPhone = agencyPhone;
    },
    ACTIVATE_TRACKING_PIXELS: function (state) {
        state.trackingPixelActivated = true;
    },
    SET_AIDA_SOURCE: function (state, aidaSource) {
        state.aidaSource = aidaSource;
    },
    SET_USER_TYPE: function (state, userType) {
        state.userType = userType;
    },
};
exports.default = {
    namespaced: true,
    state: state,
    actions: actions,
    getters: getters,
    mutations: mutations,
};
//# sourceMappingURL=store.js.map